export default __webpack_public_path__ + "static/media/patcattransparent.bb06052e.png";